import manager from '@mailobj-browser/front/js/contracts/manager.js'
import one from '@mailobj-browser/front/js/selectors/one.js'

export const load = async (id) => {
  console.log(`loading ${id} page`)
  const { content } = one(`#div_LOCAL #${id} template`)
  await manager.fragment(content.cloneNode(true))
}
